import axios from 'axios';
import { API_URL } from '../config';

const API_BASE_URL = API_URL;

export interface InterventionReport {
  id: number;
  intervention_title: string;
  intervention_description: string;
  intervention_address: string;
  intervention_status: string;
  scheduled_date: string;
  completed_date: string | null;
  completed_at?: string | null;
  customer: {
    id: number;
    name: string;
    email: string;
    phone: string;
  } | null;
  technician: {
    id: number;
    name: string;
    email: string;
    phone: string;
  } | null;
  diagnostic_report?: {
    id: number;
    problem_description: string;
    recommended_solution: string;
    materials_needed?: string;
    equipments?: Array<any>;
    parts_needed?: Array<{
      name: string;
      quantity: number;
      unit_price?: number;
    }>;
    labor_cost?: number;
    estimated_total?: number;
    urgency_level?: string;
    estimated_duration?: string;
    photos?: string[];
    notes?: string;
    technical_data?: string;
    pression?: string;
    freon?: string;
    puissance?: string;
    intensite?: string;
    tension?: string;
    status?: string;
    submitted_at?: string;
    quotes?: Array<any>;
  } | null;
  report: {
    work_description: string;
    duration: number;
    materials_used: Array<{
      name: string;
      quantity?: number;
      unit?: string;
    }>;
    observations: string;
    photos_count: number;
    status: string;
    submitted_at: string;
    // Section Équipements (nouveau format - array)
    equipments?: Array<{
      index?: number;
      name?: string;
      state?: string;
      type?: string;
      brand?: string;
      location?: string;
      tested?: boolean;
      pression?: string;
      puissance?: string;
      intensite?: string;
      tension?: string;
      freon?: string;
      before_pression?: string;
      before_puissance?: string;
      before_intensite?: string;
      before_tension?: string;
      before_freon?: string;
      after_pression?: string;
      after_puissance?: string;
      after_intensite?: string;
      after_tension?: string;
      after_freon?: string;
    }>;
    tasks_done?: Record<string, boolean>;
    photos_before?: string[];
    photos_after?: string[];
    // Section Équipement (format legacy)
    equipment_state?: string;
    equipment_type?: string;
    equipment_brand?: string;
    pression?: string;
    puissance?: string;
    temperature?: string;
    intensite?: string;
    tension?: string;
    // Section Détail Intervention
    technician_name?: string;
    intervention_date?: string;
    start_time?: string;
    end_time?: string;
    intervention_nature?: string;
    conclusion_installation?: string;
    initial_completed?: boolean;
    problem_description?: string;
    materials_needed?: string;
    location?: string;
    equipment_location?: string;
    equipment_name?: string;
    freon?: string;
    tested?: boolean;
    // Section Pièces de rechange
    spare_parts?: Array<{
      name: string;
      quantity?: number;
    }>;
  };
  initial_completed?: boolean;
  problem_description?: string;
  materials_needed?: string;
}

export interface ReportsListResponse {
  success: boolean;
  data: InterventionReport[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface ReportDetailResponse {
  success: boolean;
  data: InterventionReport;
}

const getAuthToken = () => {
  const token = localStorage.getItem('token');
  return token;
};

export const interventionReportsService = {
  // Récupérer tous les rapports (admin)
  getReports: async (params?: {
    page?: number;
    limit?: number;
    status?: string;
  }): Promise<ReportsListResponse> => {
    const token = getAuthToken();
    const response = await axios.get(`${API_BASE_URL}/admin/reports`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    });
    return response.data;
  },

  // Récupérer un rapport spécifique
  getReportById: async (interventionId: number): Promise<ReportDetailResponse> => {
    const token = getAuthToken();
    const response = await axios.get(`${API_BASE_URL}/admin/reports/${interventionId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },
};
